import { DateTime } from 'luxon'

let currentTime = DateTime.local().setZone('America/New_York')

export function updateCurrentTime () {
  currentTime = DateTime.local().setZone('America/New_York')
  // currentTime = DateTime.local(2017, 11, 19, 0, 30) // Sun morning 12:30 (OPEN)
  // currentTime = DateTime.local(2017, 11, 19, 1, 30) // Sun morning 1:30 (CLOSED)
  // currentTime = DateTime.local(2018, 11, 18, 18, 30) // Sun 18:30 (OPEN)
  // currentTime = DateTime.local(2017, 11, 18, 0, 30) // Sat morning 00:30 (OPEN)
  // currentTime = DateTime.local(2017, 11, 18, 12, 30) // Fri morning 00:30 (OPEN)
  // currentTime = DateTime.local(2017, 11, 22, 0, 30) // Closed Wednesday
  // currentTime = DateTime.local(2017, 11, 19, 8, 12) // Example closed sunday
  // currentTime = DateTime.local(2017, 11, 22, 8, 12) // Example closed wednesday
  // currentTime = DateTime.local(2017, 11, 22, 0, 0) // Example closed wednesday, 12:30am
  // currentTime = DateTime.local(2017, 11, 22, 19, 12) // Example open wednesday
  // currentTime = DateTime.local(2018, 11, 23, 14, 30)
}

function getOpeningTime (currentTime, openingTime) {
  if (currentTime.minute == 0) {
    return `Opens in ${openingTime - currentTime.hour}h`
  } else {
    return `Opens in ${openingTime - 1 - currentTime.hour}h${60 - currentTime.minute}m`
  }
}

export function getHours () {
  let hoursObject = {
    status: false,
    currentTime: currentTime,
    currentTimeFormatted: currentTime.toLocaleString(DateTime.TIME_WITH_SHORT_OFFSET),
    currentDate: currentTime.toLocaleString(DateTime.DATE_FULL)
  }

  // Closed Mon, Tue
  if (currentTime.weekday === 1 || currentTime.weekday === 2) {
    hoursObject.status = 'closed'
    hoursObject.text = 'Opens Wednesday'
    return hoursObject
  } else if (currentTime.weekday === 3 || currentTime.weekday === 4) {
    // Wed, Thu: 7–11am, 6pm–12am
    if (currentTime.hour < 7) {
      // Closed 12am-7am
      hoursObject.status = 'closed'
      hoursObject.text = getOpeningTime(currentTime, 7)
    } else if (currentTime.hour >= 11 && currentTime.hour < 18) {
      // Closed 11am-6pm
      hoursObject.status = 'closed'
      hoursObject.text = getOpeningTime(currentTime, 18)
    } else {
      if (currentTime.hour < 11) {
        // Open 7-11
        hoursObject.status = 'open'
        hoursObject.text = 'Coffee Service Now - 11 AM'
      } else {
        // Open until 12am
        hoursObject.status = 'open'
        hoursObject.text = 'Open Now - 12 AM'
      }
    }
    return hoursObject
  } else if (currentTime.weekday === 5 || currentTime.weekday === 6) {
    // Fri, Sat: 7–11am, 6pm–1am
    if (currentTime.hour >= 1 && currentTime.hour <= 7) {
      // Closed 1am-7am
      hoursObject.status = 'closed'
      hoursObject.text = getOpeningTime(currentTime, 7)
    } else if (currentTime.hour >= 11 && currentTime.hour < 18) {
      // Closed 11am-6pm
      hoursObject.status = 'closed'
      hoursObject.text = getOpeningTime(currentTime, 18)
    } else {
      if (currentTime.hour >= 1 && currentTime.hour < 11) {
        // Open 7-11
        hoursObject.status = 'open'
        hoursObject.text = 'Coffee Service Now - 11 AM'
      } else {
        // Open until 12am
        hoursObject.status = 'open'
        hoursObject.text = 'Open Now - 1 AM'
      }
    }
    return hoursObject
  } else {
    // Sunday
    // Open till 1AM, Sat Night
    if (currentTime.hour < 1) {
      hoursObject.status = 'open'
      hoursObject.text = 'Open Now - 1AM'
    } else if (currentTime.hour < 10) {
      // Closed until 10am
      hoursObject.status = 'closed'
      hoursObject.text = getOpeningTime(currentTime, 10)
    } else if (currentTime.hour >= 15 && currentTime.hour < 17) {
      // Closed 3pm-5pm
      hoursObject.status = 'closed'
      hoursObject.text = getOpeningTime(currentTime, 17)
    } else {
      if (currentTime.hour < 15) {
        // Open 7-11
        hoursObject.status = 'open'
        hoursObject.text = 'Coffee Service Now - 3 PM'
      } else {
        // Open until 12am
        hoursObject.status = 'open'
        hoursObject.text = 'Open Now - 12 AM'
      }
    }
    return hoursObject
  }
}
